{
  "messages": {
    "networkError": "Đã xảy ra lỗi mạng. Nếu sự cố vẫn tiếp diễn, vui lòng liên hệ với chúng tôi.",
    "appointmentUpdatedValidationFailed": "Cuộc hẹn đã được cập nhật nhưng không vượt qua xác thực bên ngoài.",
    "appointmentCreatedValidationFailed": "Cuộc hẹn đã được tạo nhưng không vượt qua xác thực bên ngoài.",
    "validationErrorDetail": "<br /> Lỗi xác thực: {error}"
  },
  "titles": {
    "warehouseRuleFailed": "Quy tắc kho hàng không đạt",
    "validationServerError": "Lỗi máy chủ xác thực",
    "appointmentUpdatedWithValidationError": "Cuộc hẹn đã được cập nhật kèm lỗi xác thực",
    "appointmentCreatedWithValidationError": "Cuộc hẹn đã được tạo kèm lỗi xác thực"
  }
}
